import { useState } from "react"
import Button, {
  type ButtonProps,
} from "@/v2-backoffice-client/components/button"
import LicenseAddOnManageDialog from "@/v2-backoffice-client/license/addOns/manage/LicenseAddOnManageDialog"

export type LicenseAddOnManageButtonProps = ButtonProps & {
  customerId: number
  customerName?: string
}

// The Add-ons table's primary action, placed where the Licenses table puts
// Grant license: opens the manage dialog for this customer.
function LicenseAddOnManageButton(props: LicenseAddOnManageButtonProps) {
  const { customerId, customerName, onClick, children, ...buttonProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button
        variant="primary"
        size="tiny"
        iconSrc="plus"
        iconSize={10}
        data-feature-code="UI_BackofficeCustomer_AddOns_Add"
        onClick={(e) => {
          setIsOpen(true)
          onClick?.(e)
        }}
        {...buttonProps}
      >
        {children ?? "Add add-on"}
      </Button>

      <LicenseAddOnManageDialog
        customerId={customerId}
        customerName={customerName}
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  )
}

export default LicenseAddOnManageButton
